import EditMember from "./editMember";

export default EditMember;
